import { useQuery } from "@apollo/client";
import { Link as MuiLink, Stack, Typography } from "@mui/material";
import { StatusChip } from "components/StatusChip";
import { gql } from "generated-graphql";
import { Link } from "react-router-dom";
import { DRAWER_PARAM, toDrawerParam } from "routes/Staff/GeneratorStatusChanges/drawerDeepLink";
import {
  deadlineBasis,
  deadlineChip,
} from "routes/Staff/GeneratorStatusChanges/notificationDeadline";

import { StepSubHeader } from "../StepSubHeader";

const SUBMISSION_DEADLINES = gql(`
  query GeneratorStatusSubmissionDeadlines($submissionId: ID!) {
    generatorStatusSubmissionDeadlines(submissionId: $submissionId) {
      facilityId
      facilityName
      source
      periodStart
      state
      deadlineTier
      deadlineWindowDays
      deadlineDaysRemaining
    }
  }
`);

/** Staff only: the Generator Status Review deadline for each review this notification files. */
export function NotificationDeadlines({ submissionId }: { submissionId: string }) {
  const { data } = useQuery(SUBMISSION_DEADLINES, { variables: { submissionId } });
  const deadlines = data?.generatorStatusSubmissionDeadlines ?? [];
  if (deadlines.length === 0) return null;
  return (
    <Stack spacing={1}>
      <StepSubHeader title="Notification deadline" />
      {deadlines.map((deadline) => {
        const chip = deadlineChip(deadline);
        const drawer = toDrawerParam(deadline);
        return (
          <Stack key={drawer} direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            {chip && <StatusChip color={chip.color} label={chip.label} />}
            <Typography variant="body2" color="text.secondary">
              {deadlineBasis(deadline)}
            </Typography>
            <MuiLink
              component={Link}
              to={`/staff/generator-status-changes?${DRAWER_PARAM}=${encodeURIComponent(drawer)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
            >
              {deadlines.length > 1 ? `Open ${deadline.facilityName} review` : "Open review"}
            </MuiLink>
          </Stack>
        );
      })}
    </Stack>
  );
}
